(function () {
  window.Shopify = window.Shopify || {};
  window.theme = window.theme || {};

  function getMoneyFormat() {
    return document.querySelector("[data-money-format]")?.dataset.moneyFormat || "{{amount_no_decimals_with_comma_separator}} kr";
  }

  Shopify.money_format = getMoneyFormat();

  Shopify.formatMoney = function (cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || getMoneyFormat();

    function formatWithDelimiters(number, precision = 2, thousands = ".", decimal = ",") {
      if (isNaN(number) || number == null) return "0";
      number = (number / 100.0).toFixed(precision);
      const parts = number.split(".");
      const kroner = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      const ore = parts[1] ? decimal + parts[1] : "";
      return kroner + ore;
    }

    const placeholder = formatString.match(placeholderRegex)?.[1];
    if (!placeholder) return formatString;

    let value = "";

    switch (placeholder) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  function getCartDrawer() {
    return document.getElementById("CartDrawer");
  }

  function getCartFormInner() {
    return document.querySelector("#CartDrawerForm .drawer__inner");
  }

  function getEmptyState() {
    return document.querySelector("#CartDrawerForm .drawer__cart-empty");
  }

  function formatMoney(cents) {
    return Shopify.formatMoney(cents, getMoneyFormat());
  }

  function parseJSONSafe(value, fallback = null) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function getVisibleCartCount(cartData) {
    let visibleCount = 0;

    if (cartData && Array.isArray(cartData.items)) {
      cartData.items.forEach(function (item) {
        const isBundleChild = item?.properties?._bundle_role === "child";
        if (!isBundleChild) {
          visibleCount += item.quantity || 0;
        }
      });
    }

    return visibleCount;
  }

  function initVariantSelectors(scope = document) {
    const selects = scope.querySelectorAll(".variant-select");

    selects.forEach(function (select) {
      if (select.dataset.variantSelectorBound === "true") return;
      select.dataset.variantSelectorBound = "true";

      const variantsJSON = select.dataset.variants;
      if (!variantsJSON) return;

      const variants = parseJSONSafe(variantsJSON, []);
      if (!Array.isArray(variants) || !variants.length) return;

      const productEl = select.closest(".custom-related-product");
      const productData = productEl?.dataset?.product ? parseJSONSafe(productEl.dataset.product, null) : null;

      select.addEventListener("change", function () {
        const selectedId = this.value;
        const variant = variants.find(function (v) {
          return String(v.id) === String(selectedId);
        });

        if (!variant) return;

        const qtyWrappers = productEl?.querySelectorAll(".custom-qty-wrapper");
        let currentQty = 1;

        qtyWrappers?.forEach(function (wrapper) {
          const qtyInput = wrapper.querySelector("input.qty-input");
          if (qtyInput) {
            currentQty = parseInt(qtyInput.value, 10) || 1;
          }
        });

        const priceContainer = productEl?.querySelector(".custom-related-product__price");
        if (!priceContainer) return;

        priceContainer.innerHTML = "";

        if (variant.compare_at_price > variant.price) {
          const wasPrice = document.createElement("span");
          wasPrice.className = "was-price";
          wasPrice.style.textDecoration = "line-through";
          wasPrice.style.color = "#888";
          wasPrice.textContent = formatMoney(variant.compare_at_price);
          priceContainer.appendChild(wasPrice);
        }

        const currentPrice = document.createElement("span");
        currentPrice.className = "current-price";
        currentPrice.style.fontWeight = "bold";
        currentPrice.style.marginLeft = "5px";
        currentPrice.textContent = formatMoney(variant.price);
        priceContainer.appendChild(currentPrice);

        let badgeText =
          variant?.metafields?.custom?.badge_text ||
          productData?.metafields?.custom?.badge_text ||
          productEl?.dataset?.productBadge ||
          null;

        if (badgeText) {
          const badge = document.createElement("div");
          badge.className = "custom-badge-text";
          badge.style.marginTop = "5px";
          badge.style.fontSize = "13px";
          badge.style.color = "#444";
          badge.textContent = badgeText;
          priceContainer.appendChild(badge);
        }

        qtyWrappers?.forEach(function (wrapper) {
          const qtyInput = wrapper.querySelector("input.qty-input");
          if (qtyInput) {
            qtyInput.value = currentQty;
            qtyInput.setAttribute("value", currentQty);
          }
        });
      });
    });
  }

  function initAjaxAddToCart(scope = document) {
    const forms = scope.querySelectorAll('.custom-related-product form[action^="/cart/add"]');

    forms.forEach(function (form) {
      if (form.dataset.ajaxListenerAttached === "true") return;
      form.dataset.ajaxListenerAttached = "true";

      const variantSelect = form.querySelector('select[name="id"]');
      const submitBtn = form.querySelector('button[type="submit"], .add-to-cart');

      if (variantSelect && submitBtn) {
        submitBtn.disabled = !variantSelect.value;

        variantSelect.addEventListener("change", function () {
          submitBtn.disabled = !this.value;
        });
      }

      form.addEventListener("submit", async function (e) {
        e.preventDefault();

        const variantInput = form.querySelector('input[name="id"], select[name="id"]');
        const qtyInput = form.querySelector('input[name="quantity"]');
        const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        const originalBtnText = submitBtn ? submitBtn.textContent : "";

        if (!variantInput || !variantInput.value) {
          if (submitBtn) {
            submitBtn.textContent = "Vælg variant";
            setTimeout(function () {
              submitBtn.textContent = originalBtnText || "Tilføj til kurv";
            }, 2000);
          }
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = "Tilføjer...";
        }

        try {
          const formData = new FormData(form);
          formData.set("id", variantInput.value);
          formData.set("quantity", quantity);

          const res = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
            headers: { Accept: "application/json" },
            credentials: "same-origin"
          });

          if (!res.ok) throw new Error("Fejl ved tilføjelse");

          const data = await res.json();

          if (submitBtn) {
            submitBtn.textContent = "Tilføjet!";
          }

          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: { product: data }
            })
          );

          const cartRes = await fetch("/cart.js", { credentials: "same-origin", cache: "no-store" });
          const cartData = await cartRes.json();
          updateCartCountBubble(cartData);

          setTimeout(function () {
            if (submitBtn) {
              submitBtn.textContent = originalBtnText || "Tilføj til kurv";
              submitBtn.disabled = false;
            }
          }, 1000);
        } catch (error) {
          console.error("Fejl ved tilføjelse:", error);

          if (submitBtn) {
            submitBtn.textContent = "Fejl";
            setTimeout(function () {
              submitBtn.textContent = originalBtnText || "Tilføj til kurv";
              submitBtn.disabled = false;
            }, 2000);
          }
        }
      });
    });
  }

  function initLoadMore() {
    const loadMoreBtn = document.querySelector(".js-load-more");
    if (!loadMoreBtn || loadMoreBtn.dataset.loadMoreBound === "true") return;

    loadMoreBtn.dataset.loadMoreBound = "true";

    loadMoreBtn.addEventListener("click", async function () {
      const totalPages = parseInt(document.querySelector("[data-total-pages]")?.value || "1", 10);
      let currentPage = parseInt(document.querySelector("[data-current-page]")?.value || "1", 10);
      const nextUrlInput = document.querySelector("[data-next-url]");
      if (!nextUrlInput) return;

      const loader = loadMoreBtn.querySelector("[loader]");
      const loadMoreText = loadMoreBtn.querySelector("[load-more-text]");

      loadMoreBtn.disabled = true;
      loader?.classList.remove("hide");
      loadMoreText?.classList.add("hide");

      currentPage += 1;
      const nextUrl = nextUrlInput.value.replace(/page=\d+/, "page=" + currentPage);
      const currentPageInput = document.querySelector("[data-current-page]");
      if (currentPageInput) currentPageInput.value = currentPage;

      try {
        const res = await fetch(nextUrl);
        const html = await res.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const newItems = tempDiv.querySelector(".grid--view-items");
        const container = document.querySelector(".grid--view-items");

        if (newItems && container) {
          container.insertAdjacentHTML("beforeend", newItems.innerHTML);
          runInitializers(container);
        }
      } catch (error) {
        console.error("Load more fejlede:", error);
      } finally {
        if (currentPage < totalPages) {
          loadMoreBtn.disabled = false;
          loader?.classList.add("hide");
          loadMoreText?.classList.remove("hide");
        }
      }
    });
  }

  function initVariantMetafieldHTML() {
    if (document.body.dataset.variantMetafieldBound === "true") return;
    document.body.dataset.variantMetafieldBound = "true";

    document.addEventListener("variant:change", function (event) {
      const wrapper = document.querySelector(".custom--product-variant-custom-html__wrapper");
      const variantId = event.detail?.variant?.id?.toString();

      if (!wrapper || !variantId) return;

      const fullUrl = window.location.href.split("?")[0] + "?view=json";

      fetch(fullUrl, { credentials: "same-origin" })
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          const json = JSON.parse(html);
          const variant = json.variants?.find(function (v) {
            return String(v.id) === String(variantId);
          });

          if (variant?.metafield_custom_html) {
            const temp = document.createElement("textarea");
            temp.innerHTML = variant.metafield_custom_html;
            wrapper.innerHTML = temp.value;
          } else {
            wrapper.innerHTML = "";
          }
        })
        .catch(function (err) {
          console.error("Fejl ved AJAX/metafield load:", err);
        });
    });
  }

  function initVariantMetaFields() {
    if (document.body.dataset.variantMetaFieldsBound === "true") return;
    document.body.dataset.variantMetaFieldsBound = "true";

    function updateVariantMetaFieldsFromSection(section, variant) {
      if (!section || !variant) return;

      const badgeTarget = section.querySelector("[data-variant-badge]");
      const htmlTarget = section.querySelector("[data-variant-html]");

      if (!badgeTarget && !htmlTarget) return;

      const badgeText =
        variant?.metafields?.custom?.badge_text ||
        variant?.metafields?.badge_text ||
        "";

      const customHtml =
        variant?.metafields?.custom?.custom_html ||
        variant?.metafields?.custom_html ||
        "";

      if (badgeTarget) {
        badgeTarget.innerHTML = badgeText || "";
      }

      if (htmlTarget) {
        htmlTarget.innerHTML = customHtml || "";
      }
    }

    function updateFromCurrentVariantJSON(section) {
      if (!section) return;

      const currentVariantJson = section.querySelector("[data-current-variant-json]");
      if (!currentVariantJson) return;

      const currentVariant = parseJSONSafe(currentVariantJson.textContent, null);
      if (!currentVariant) return;

      updateVariantMetaFieldsFromSection(section, currentVariant);
    }

    document.querySelectorAll(".product-section").forEach(function (section) {
      updateFromCurrentVariantJSON(section);
    });

    document.addEventListener("variant:change", function (event) {
      const variant = event.detail?.variant;
      const section =
        event.target?.closest?.(".product-section") ||
        document.querySelector(".product-section");

      if (!variant || !section) return;
      updateVariantMetaFieldsFromSection(section, variant);
    });
  }

  function initSizeFilter() {
    const sizeFilter = document.getElementById("SizeFilter");
    if (!sizeFilter || sizeFilter.dataset.sizeFilterBound === "true") return;

    sizeFilter.dataset.sizeFilterBound = "true";

    sizeFilter.addEventListener("change", function () {
      const selected = this.value;
      const url = new URL(window.location.href);

      if (selected) {
        url.searchParams.set("size", selected);
      } else {
        url.searchParams.delete("size");
      }

      window.location.href = url.href;
    });
  }

  function initGlobalQtyButtons() {
    if (window.__customQtyClickBound) return;
    window.__customQtyClickBound = true;

    document.addEventListener("click", function (e) {
      if (e.target.closest("#CartDrawer")) return;

      const plusBtn = e.target.closest(".qty-plus");
      const minusBtn = e.target.closest(".qty-minus");

      if (plusBtn) {
        e.preventDefault();
        e.stopPropagation();

        const wrapper = plusBtn.closest(".custom-qty-wrapper");
        const input = wrapper?.querySelector(".qty-input");

        if (input) {
          const val = parseInt(input.value, 10) || 1;
          input.value = val + 1;
          input.setAttribute("value", input.value);
        }

        return;
      }

      if (minusBtn) {
        e.preventDefault();
        e.stopPropagation();

        const wrapper = minusBtn.closest(".custom-qty-wrapper");
        const input = wrapper?.querySelector(".qty-input");

        if (input) {
          const val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
            input.setAttribute("value", input.value);
          }
        }
      }
    });
  }

  function syncReadMoreButton(desc) {
    const sibling = desc.nextElementSibling;
    if (sibling && sibling.matches && sibling.matches("[data-collection-readmore]")) {
      sibling.textContent = desc.classList.contains("expanded") ? "Læs mindre" : "Læs mere";
    }
  }

  function initTextToggles() {
    if (document.body.dataset.textToggleBound === "true") return;
    document.body.dataset.textToggleBound = "true";

    document.addEventListener("click", function (e) {
      // Tydelig "Læs mere/Læs mindre"-knap
      const readmore = e.target.closest("[data-collection-readmore]");
      if (readmore) {
        const desc = readmore.previousElementSibling;
        if (desc && desc.matches("[data-collection-toggle]")) {
          desc.classList.toggle("expanded");
          syncReadMoreButton(desc);
          const heroEl = desc.closest(".wl-collection-hero--image");
          if (heroEl) {
            heroEl.classList.toggle("hero-is-expanded", desc.classList.contains("expanded"));
          }
        }
        return;
      }

      const toggle = e.target.closest("[data-short-text], [data-collection-toggle]");
      if (!toggle) return;

      toggle.classList.toggle("expanded");
      syncReadMoreButton(toggle);

      const hero = toggle.closest(".wl-collection-hero--image");
      if (hero) {
        hero.classList.toggle("hero-is-expanded", toggle.classList.contains("expanded"));
      }
    });
  }

  function initCollectionReadMore(scope = document) {
    scope.querySelectorAll("[data-collection-toggle]").forEach(function (desc) {
      if (desc.dataset.readmoreBound === "true") return;
      desc.dataset.readmoreBound = "true";

      // Tilfoej kun knappen hvis teksten faktisk er afkortet
      if (desc.scrollHeight <= desc.clientHeight + 2) return;
      if (desc.nextElementSibling && desc.nextElementSibling.matches("[data-collection-readmore]")) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "collection-hero__readmore";
      btn.setAttribute("data-collection-readmore", "");
      btn.textContent = "Læs mere";
      desc.insertAdjacentElement("afterend", btn);
    });
  }

  function updateCartCountBubble(cartData) {
    const visibleCount = getVisibleCartCount(cartData);
    const bubbles = document.querySelectorAll(
      ".cart-link__bubble, .cart-link__bubble--visible, [data-cart-count], .site-header__cart-count"
    );

    bubbles.forEach(function (bubble) {
      bubble.textContent = visibleCount;

      if (bubble.classList.contains("cart-link__bubble") || bubble.classList.contains("cart-link__bubble--visible")) {
        if (visibleCount > 0) {
          bubble.classList.add("cart-link__bubble--visible");
          bubble.style.display = "";
        } else {
          bubble.classList.remove("cart-link__bubble--visible");
          bubble.style.display = "none";
        }
      }
    });
  }

  function getFreeShippingBar() {
    return document.querySelector("#CartDrawer free-shipping-bar") || document.querySelector("free-shipping-bar");
  }

  function calculateFreeShippingData(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const discountApplications = Array.isArray(cart?.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];

    const priceForItems = items
      .filter(function (item) {
        return item && item.requires_shipping;
      })
      .reduce(function (sum, item) {
        return sum + (item.final_line_price || 0);
      }, 0);

    const cartDiscount = discountApplications.reduce(function (sum, discountAllocation) {
      return sum + (discountAllocation.total_allocated_amount || 0);
    }, 0);

    return {
      totalPrice: Math.max(0, priceForItems - cartDiscount),
      hasShippableItems: items.some(function (item) {
        return item && item.requires_shipping;
      })
    };
  }

  function renderFreeShippingBarFromCart(cartData) {
    const freeShippingBar = getFreeShippingBar();
    if (!freeShippingBar) return;

    const threshold = parseFloat(freeShippingBar.getAttribute("threshold")) || 0;
    const progressBar = freeShippingBar.querySelector("progress-bar");
    const messageTarget = freeShippingBar.querySelector("span");
    if (!progressBar || !messageTarget) return;

    const shippingData = calculateFreeShippingData(cartData);

    if (!shippingData.hasShippableItems) {
      freeShippingBar.style.display = "none";
      return;
    }

    freeShippingBar.style.display = "";

    const safeThreshold = threshold > 0 ? threshold : 0;
    const remainingAmount = Math.max(0, safeThreshold - shippingData.totalPrice);
    const progressPercentage = safeThreshold > 0
      ? Math.min(100, (shippingData.totalPrice / safeThreshold) * 100)
      : 0;

    progressBar.style.setProperty("--progress", progressPercentage / 100);
    progressBar.setAttribute("aria-valuenow", String(Math.round(progressPercentage)));

    const reachedMessage = freeShippingBar.getAttribute("reached-message") || "";
    const unreachedMessage = freeShippingBar.getAttribute("unreached-message") || "";

    const message =
      safeThreshold > 0 && shippingData.totalPrice >= safeThreshold
        ? reachedMessage
        : unreachedMessage.replace("[remaining_amount]", formatMoney(remainingAmount));

    messageTarget.innerHTML = message;
  }

  let refreshInProgress = false;

  function updateCartSummary(cartData) {
    const subtotalEl = document.querySelector("[data-subtotal]");
    if (subtotalEl) subtotalEl.innerHTML = formatMoney(cartData.total_price);

    const vatEl = document.querySelector("[data-cart-vat]");
    if (vatEl) vatEl.innerHTML = formatMoney(Math.round((cartData.total_price * 20) / 120));

    const savingsRow = document.querySelector("[data-cart-savings-row]");
    const savingsEl = document.querySelector("[data-cart-savings]");
    const savings = Math.max(0, (cartData.original_total_price || 0) - (cartData.total_price || 0));

    if (savingsRow && savingsEl) {
      if (savings > 0) {
        savingsRow.classList.remove("hide");
        savingsEl.innerHTML = "-" + formatMoney(savings);
      } else {
        savingsRow.classList.add("hide");
        savingsEl.innerHTML = "";
      }
    }
  }

  function updateCartShippingText(cartData) {
    const el = document.querySelector("[data-cart-shipping]");
    if (!el) return;

    const shippingData = calculateFreeShippingData(cartData);
    const threshold = parseFloat(getFreeShippingBar()?.getAttribute("threshold")) || 0;

    el.textContent = threshold > 0 && shippingData.totalPrice >= threshold ? "Gratis fragt" : "Beregnes ved checkout";
  }

  function toggleEmptyCart(cartData) {
  var cartDrawer = document.getElementById("CartDrawer");
  var cartInner = document.querySelector("#CartDrawerForm .drawer__inner");
  var emptyState = document.querySelector("#CartDrawerForm .drawer__cart-empty");

  if (!cartDrawer || !cartInner || !emptyState) return;

  if (cartData.item_count === 0) {
    cartDrawer.classList.add("is-empty");
  } else {
    cartDrawer.classList.remove("is-empty");
  }
}

  function changeCartItemByKey(key, quantity) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify({
      id: key,
      quantity: quantity
    })
  }).then(function (response) {
    return response.json();
  });
}

function updateLineItem(key, quantity) {
  if (!key) return Promise.reject(new Error("Manglende line item key"));

  quantity = parseInt(quantity, 10);
  if (isNaN(quantity) || quantity < 0) {
    quantity = 0;
  }

  return fetch("/cart.js", {
    credentials: "same-origin",
    cache: "no-store"
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) {
        throw new Error("Kunne ikke hente kurven");
      }

      var targetItem = cart.items.find(function (item) {
        return item.key === key;
      });

      if (!targetItem) {
        throw new Error("Kunne ikke finde line item i kurven");
      }

      var isBundleParent =
        targetItem.properties &&
        targetItem.properties._bundle_type === "bedding_set" &&
        targetItem.properties._bundle_role === "parent";

      if (!isBundleParent) {
        return changeCartItemByKey(key, quantity);
      }

      var childLinkKey = targetItem.properties._child_link_key;
      var qtyPerSet = parseInt(targetItem.properties._linked_pillow_quantity_per_set || "1", 10);

      if (isNaN(qtyPerSet) || qtyPerSet < 1) {
        qtyPerSet = 1;
      }

      if (!childLinkKey) {
        return changeCartItemByKey(key, quantity);
      }

      var childItem = cart.items.find(function (item) {
        return item.properties &&
          item.properties._bundle_type === "bedding_set" &&
          item.properties._bundle_role === "child" &&
          item.properties._bundle_key === childLinkKey;
      });

      var currentParentQty = parseInt(targetItem.quantity || 0, 10);
      var qtyDelta = quantity - currentParentQty;
      var childDelta = qtyDelta * qtyPerSet;

      if (quantity === 0) {
        if (childItem) {
          var newChildQtyOnRemove = Math.max(0, (childItem.quantity || 0) - (currentParentQty * qtyPerSet));

          return changeCartItemByKey(childItem.key, newChildQtyOnRemove).then(function () {
            return changeCartItemByKey(key, 0);
          });
        }

        return changeCartItemByKey(key, 0);
      }

      return changeCartItemByKey(key, quantity).then(function () {
        if (childItem) {
          var newChildQty = Math.max(0, (childItem.quantity || 0) + childDelta);
          return changeCartItemByKey(childItem.key, newChildQty);
        }
      });
    })
    .then(function () {
      return refreshCartContents();
    });
}

  function addUpsellToCart(variantId) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Upsell fejl");
        return res.json();
      })
      .then(function () {
        return refreshCartContents();
      });
  }

  // Qty-knapper i kurven. Vi haandterer ALLE kurv-linjer (bundle som ikke-bundle)
  // via een capture-fase-listener paa document, og stopper Impulses egen
  // theme.QtySelector i ogsaa at koere paa samme klik (stopImmediatePropagation).
  //
  // Hvorfor: Impulses QtySelector (a) opdaterer kun den klikkede linje uden at
  // synkronisere medfoelgende pudebetraek, og (b) bindes kun naar en linje
  // foerst renderes, saa nyligt AJAX-tilfoejede varer ikke virkede foer reload.
  // Vores updateLineItem haandterer baade bundle-parent (synkroniserer pude) og
  // almindelige varer, saa een listener daekker alt paalideligt.
  function bindQtyButtons() {
    if (window.__wlCartQtyBound) return;
    window.__wlCartQtyBound = true;

    document.addEventListener(
      "click",
      function (e) {
        var button = e.target.closest(".js-qty__adjust");
        if (!button) return;

        // Kun inde i kurven (drawer eller cart-side), ikke fx produktside-qty.
        if (!button.closest("#CartDrawer, #CartDrawerForm, #CartPageForm")) return;

        var wrapper = button.closest(".js-qty__wrapper");
        if (!wrapper) return;

        var input = wrapper.querySelector(".js-qty__num");
        if (!input) return;

        // Overtag klikket helt saa Impulses QtySelector ikke ogsaa koerer.
        e.preventDefault();
        e.stopImmediatePropagation();

        if (button.disabled) return;

        var key = input.dataset.id;
        var currentQty = parseInt(input.value, 10);
        if (isNaN(currentQty)) currentQty = 0;

        var newQty = currentQty;

        if (button.classList.contains("js-qty__adjust--plus")) {
          newQty = currentQty + 1;

          var maxQty = parseInt(input.dataset.maxQty || "0", 10);
          if (maxQty > 0 && newQty > maxQty) {
            return;
          }
        }

        if (button.classList.contains("js-qty__adjust--minus")) {
          newQty = Math.max(currentQty - 1, 0);
        }

        if (newQty === currentQty) return;

        button.disabled = true;
        input.value = newQty;

        updateLineItem(key, newQty).finally(function () {
          button.disabled = false;
        });
      },
      true
    );
  }

  function bindRemoveButtons() {
    if (document.body.dataset.removeBound === "true") return;
    document.body.dataset.removeBound = "true";

    document.addEventListener("click", function (event) {
      var cartDrawer = getCartDrawer();
      if (!cartDrawer) return;

      var button = event.target.closest(".cart__remove-button");
      if (!button || !cartDrawer.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.disabled) return;
      button.disabled = true;

      var key = button.dataset.removeKey;
      if (!key) {
        button.disabled = false;
        return;
      }

      updateLineItem(key, 0).finally(function () {
        button.disabled = false;
      });
    });
  }

  function bindUpsellButtons() {
    if (document.body.dataset.upsellBound === "true") return;
    document.body.dataset.upsellBound = "true";

    document.addEventListener("click", function (event) {
      var button = event.target.closest(".add-upsell-to-cart");
      if (!button) return;

      event.preventDefault();

      if (button.disabled) return;

      var variantId = button.dataset.id;
      button.disabled = true;
      button.textContent = "Tilføjer...";

      addUpsellToCart(variantId)
        .then(function () {
          if (!button.closest("#CartDrawer, #CartDrawerForm, #CartPageForm")) {
            document.dispatchEvent(new CustomEvent("cart:open"));
          }
        })
        .catch(function (error) {
          console.error("Fejl ved tilkøb:", error);
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = "Læg i kurv";
        });
    });
  }

  function bindSummaryToggle() {
    var toggle = document.getElementById("cartSummaryToggle");
    var details = document.getElementById("cartSummaryDetails");

    if (!toggle || !details) return;
    if (toggle.dataset.bound === "true") return;
    toggle.dataset.bound = "true";

    toggle.addEventListener("click", function () {
      var isOpen = toggle.getAttribute("aria-expanded") === "true";

      toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
      toggle.textContent = isOpen ? "Vis detaljer" : "Skjul detaljer";
      details.hidden = isOpen;
    });
  }

  function bindGiftQuestion() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    var input = drawer.querySelector('input[name="attributes[Er dette en gave?]"]');
    var dropdown = document.getElementById("giftWrapDropdown");

    if (!input) return;
    if (input.dataset.bound === "true") return;
    input.dataset.bound = "true";

    input.addEventListener("change", function () {
      if (dropdown) {
        dropdown.hidden = !this.checked;
      }

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify({
          attributes: {
            "Er dette en gave?": this.checked ? "Ja" : ""
          }
        })
      }).catch(function (error) {
        console.error("Fejl ved gaveattribut:", error);
      });
    });
  }

  function updateGiftWrapAvailability(cartData, flags) {
    var drawer = getCartDrawer();
    if (!drawer) return;

    var giftSection = drawer.querySelector("[data-gift-question]");
    if (!giftSection) return;

    if (flags) {
      giftSection.dataset.hasWrappable = flags.hasWrappable ? "true" : "false";
      giftSection.dataset.hasUnwrappable = flags.hasUnwrappable ? "true" : "false";
    }

    var hasWrappable = giftSection.dataset.hasWrappable === "true";
    var hasUnwrappable = giftSection.dataset.hasUnwrappable === "true";

    var giftWrapItem = null;
    if (cartData && cartData.items) {
      giftWrapItem = cartData.items.find(function (item) {
        return item.handle === "gaveindpakning";
      }) || null;
    }
    var giftWrapInCart = giftWrapItem !== null;

    // Ligger gaveindpakningen i kurven uden at der er noget at pakke ind
    // (kun undtagne varer tilbage), fjernes den automatisk (Mads' beslutning 2. juli 2026).
    if (giftWrapItem && !hasWrappable && hasUnwrappable) {
      changeCartItemByKey(giftWrapItem.key, 0)
        .then(function () {
          return refreshCartContents();
        })
        .catch(function (error) {
          console.error("Fejl ved auto-fjernelse af gaveindpakning:", error);
        });
    }

    var blocked = !hasWrappable;
    var addButton = giftSection.querySelector("[data-gift-wrap-add]");
    var blockedNote = giftSection.querySelector("[data-gift-wrap-blocked-note]");
    var warningNote = giftSection.querySelector("[data-gift-wrap-warning-note]");

    if (addButton) addButton.disabled = blocked;
    if (blockedNote) blockedNote.hidden = !blocked;
    if (warningNote) warningNote.hidden = !(giftWrapInCart && hasUnwrappable && !blocked);
  }

  // Tilkoebs-bokse paa produktsiden med kurv-betingelse (fx brodering kraever
  // et produkt med tagget brodering-mulig i kurven).
  function updateAddonUpsellRequirements(cartTags) {
    document.querySelectorAll("[data-addon-upsell][data-requires-cart-tag]").forEach(function (box) {
      var tag = box.dataset.requiresCartTag;
      if (!tag) return;

      var met = cartTags.indexOf(tag) !== -1;
      var addButton = box.querySelector(".add-upsell-to-cart");
      var note = box.querySelector("[data-addon-requires-note]");

      if (addButton) addButton.disabled = !met;
      if (note) note.hidden = met;
    });
  }

  // Ligger brodering i kurven uden broderbare varer (tag brodering-mulig),
  // og kurven ikke KUN bestaar af brodering, fjernes den automatisk,
  // samme princip som gaveindpakningen (Mads' beslutning 2. juli 2026).
  function updateEmbroideryCartRule(cartData, cartTags) {
    if (!cartData || !Array.isArray(cartData.items)) return;

    var embroideryItem = cartData.items.find(function (item) {
      return item.handle === "brodering-pa-sengetoj";
    });
    if (!embroideryItem) return;

    var hasEmbroiderable = cartTags.indexOf("brodering-mulig") !== -1;
    var hasOtherItems = cartData.items.some(function (item) {
      return item.handle !== "brodering-pa-sengetoj";
    });

    if (!hasEmbroiderable && hasOtherItems) {
      changeCartItemByKey(embroideryItem.key, 0)
        .then(function () {
          return refreshCartContents();
        })
        .catch(function (error) {
          console.error("Fejl ved auto-fjernelse af brodering:", error);
        });
    }
  }

  function bindCartEvents() {
    bindQtyButtons();
    bindRemoveButtons();
    bindUpsellButtons();
    bindSummaryToggle();
    bindGiftQuestion();
  }

  function refreshCartContents() {
    if (refreshInProgress) return Promise.resolve();
    refreshInProgress = true;

    return Promise.all([
      fetch("/cart?view=ajax&_=" + Date.now(), {
        credentials: "same-origin",
        cache: "no-store"
      }).then(function (res) {
        return res.text();
      }),
      fetch("/cart.js", {
        credentials: "same-origin",
        cache: "no-store"
      }).then(function (res) {
        return res.json();
      })
    ])
      .then(function (results) {
        const html = results[0];
        const cartData = results[1];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const cartDrawer = getCartDrawer();

        if (!cartDrawer) {
          if (window.location.pathname === "/cart") {
            window.location.reload();
          }
          return;
        }

        const ajaxProducts = doc.querySelector("[data-products]");
        const currentProducts = cartDrawer.querySelector("[data-products]");

        if (ajaxProducts && currentProducts) {
          currentProducts.innerHTML = ajaxProducts.innerHTML;
        }

        const ajaxDiscounts = doc.querySelector("[data-discounts]");
        const currentDiscounts = cartDrawer.querySelector("[data-discounts]");

        if (ajaxDiscounts && currentDiscounts) {
          currentDiscounts.innerHTML = ajaxDiscounts.innerHTML;
          currentDiscounts.className = ajaxDiscounts.className;
        }

        if (ajaxProducts) {
          updateGiftWrapAvailability(cartData, {
            hasWrappable: ajaxProducts.dataset.hasWrappable === "true",
            hasUnwrappable: ajaxProducts.dataset.hasUnwrappable === "true"
          });

          var cartTags = (ajaxProducts.dataset.cartTags || "")
            .split(",")
            .map(function (tag) { return tag.trim(); })
            .filter(Boolean);

          updateAddonUpsellRequirements(cartTags);
          updateEmbroideryCartRule(cartData, cartTags);
        } else {
          updateGiftWrapAvailability(cartData);
        }

        updateCartSummary(cartData);
        updateCartShippingText(cartData);
        renderFreeShippingBarFromCart(cartData);
        updateCartCountBubble(cartData);
        toggleEmptyCart(cartData);
        bindCartEvents();
      })
      .catch(function (error) {
        console.error("Fejl ved refresh af cart drawer:", error);
      })
      .finally(function () {
        refreshInProgress = false;
      });
  }

  window.refreshCartDrawerContents = refreshCartContents;

  function initCartDrawer() {
    bindCartEvents();

    fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        updateCartSummary(data);
        updateCartShippingText(data);
        renderFreeShippingBarFromCart(data);
        updateCartCountBubble(data);
        toggleEmptyCart(data);
        updateGiftWrapAvailability(data);
      })
      .catch(function (error) {
        console.error("Fejl ved init af cart drawer:", error);
      });

    document.addEventListener("ajaxProduct:added", function () {
      refreshCartContents();
    });

    document.addEventListener("cart:updated", function () {
      fetch("/cart.js", {
        credentials: "same-origin",
        cache: "no-store"
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          updateCartSummary(data);
          updateCartShippingText(data);
          renderFreeShippingBarFromCart(data);
          updateCartCountBubble(data);
          toggleEmptyCart(data);
          updateGiftWrapAvailability(data);
        })
        .catch(function (error) {
          console.error("Fejl ved cart:updated:", error);
        });
    });
  }

  function initBeddingBundle(scope = document) {
    const pickers = scope.querySelectorAll("[data-bedding-bundle-picker]");

    pickers.forEach(function (picker) {
      if (picker.dataset.beddingBundleBound === "true") return;
      picker.dataset.beddingBundleBound = "true";

      const section = picker.closest(".product-section");
      if (!section) return;

      const duvetSelect = section.querySelector("[data-bedding-duvet-select]");
      const pillowSelect = section.querySelector("[data-bedding-pillow-select]");
      const helper = section.querySelector("[data-bedding-bundle-helper]");
      const pillowVariantIdInput = section.querySelector("[data-linked-pillow-variant-id]");
      const pillowVariantLabelInput = section.querySelector("[data-linked-pillow-variant-label]");
      const pillowQuantityInput = section.querySelector("[data-linked-pillow-quantity]");
      const pillowCountLabel = section.querySelector("[data-bedding-pillow-count-label]");
      const form = section.querySelector('form[action^="/cart/add"]');
      const addToCartBtns = section.querySelectorAll(".add-to-cart, [data-add-to-cart]");
      const addToCartTexts = section.querySelectorAll("[data-add-to-cart-text]");
      const productTitle = section.dataset.productTitle || "";
      const defaultAddToCartText = addToCartTexts.length
        ? addToCartTexts[0].textContent.trim()
        : "Tilføj til kurv";

      if (!duvetSelect || !pillowSelect || !form) return;

      const variantJsonEl = section.querySelector("[data-variant-json]");
      const variants = variantJsonEl ? parseJSONSafe(variantJsonEl.textContent, []) : [];

      function getFirstAvailablePillowOption() {
        return Array.from(pillowSelect.options).find(function (option) {
          return !option.disabled;
        });
      }

      function ensureValidPillowSelection() {
        const selectedOption = pillowSelect.options[pillowSelect.selectedIndex];
        if (selectedOption && !selectedOption.disabled) return selectedOption;

        const firstAvailable = getFirstAvailablePillowOption();
        if (firstAvailable) {
          pillowSelect.value = firstAvailable.value;
          return firstAvailable;
        }

        return selectedOption || null;
      }

      function getPillowCountByDuvetTitle(title) {
        if (!title) return 1;
        return title.includes("200x200") || title.includes("200x220") || title.includes("240x220") ? 2 : 1;
      }

      function setAddToCartState(isAvailable, soldOutText) {
        const text = isAvailable ? defaultAddToCartText : soldOutText || "Midlertidigt udsolgt";

        addToCartBtns.forEach(function (btn) {
          btn.disabled = !isAvailable;
          btn.setAttribute("aria-disabled", String(!isAvailable));

          if (!addToCartTexts.length) {
            btn.textContent = text;
          }
        });

        addToCartTexts.forEach(function (el) {
          el.textContent = text;
        });
      }

      function updateMainVariantUI(variantId) {
        const variant = variants.find(function (v) {
          return String(v.id) === String(variantId);
        });

        if (!variant) return;

        const priceEl = section.querySelector("[data-product-price]");
        const compareWrapEl = section.querySelector("[data-product-price-wrap]");
        const compareEl = section.querySelector("[data-compare-price]");
        const saveEl = section.querySelector("[data-save-price]");
        const unitPriceWrapEl = section.querySelector("[data-unit-price-wrapper]");
        const unitPriceEl = section.querySelector("[data-unit-price]");
        const unitBaseEl = section.querySelector("[data-unit-base]");
        const skuEl = section.querySelector("[data-sku]");
        const hiddenIdInput = form.querySelector('[name="id"]');

        if (hiddenIdInput) {
          hiddenIdInput.value = variant.id;
        }

        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price);
          if (variant.compare_at_price > variant.price) {
            priceEl.classList.add("on-sale");
          } else {
            priceEl.classList.remove("on-sale");
          }
        }

        if (compareWrapEl && compareEl) {
          if (variant.compare_at_price > variant.price) {
            compareWrapEl.classList.remove("hide");
            compareEl.textContent = formatMoney(variant.compare_at_price);
          } else {
            compareWrapEl.classList.add("hide");
            compareEl.textContent = "";
          }
        }

        if (saveEl) {
          if (variant.compare_at_price > variant.price) {
            const savedAmount = variant.compare_at_price - variant.price;
            saveEl.classList.remove("hide");
            saveEl.textContent = "Spar " + formatMoney(savedAmount);
          } else {
            saveEl.classList.add("hide");
            saveEl.textContent = "";
          }
        }

        if (unitPriceWrapEl && unitPriceEl && unitBaseEl) {
          if (variant.unit_price_measurement && variant.unit_price) {
            unitPriceWrapEl.classList.remove("hide");
            unitPriceEl.textContent = formatMoney(variant.unit_price);

            let base = "";
            if (variant.unit_price_measurement.reference_value !== 1) {
              base += variant.unit_price_measurement.reference_value;
            }
            base += variant.unit_price_measurement.reference_unit;
            unitBaseEl.textContent = base;
          } else {
            unitPriceWrapEl.classList.add("hide");
            unitPriceEl.textContent = "";
            unitBaseEl.textContent = "";
          }
        }

        if (skuEl) {
          skuEl.textContent = variant.sku || "";
        }

        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }

      function updateHelper(showMessage) {
  const selectedDuvetOption = duvetSelect.options[duvetSelect.selectedIndex] || null;
  const selectedDuvetText = selectedDuvetOption ? selectedDuvetOption.text : "";
  const selectedDuvetValue = duvetSelect.value || "";

  const hasAvailableDuvetOption = Array.from(duvetSelect.options).some(function(option) {
    return option.value !== "" && option.getAttribute("data-soldout") !== "true";
  });

  const selectedPillowOption = ensureValidPillowSelection();
  const pillowCount = getPillowCountByDuvetTitle(selectedDuvetText);
        Array.from(pillowSelect.options).forEach(function(option) {
  var baseLabel = option.getAttribute("data-base-label") || option.getAttribute("data-label") || option.text;
  var isPlaceholder = option.value === "";
  // Udsolgt-tekst ogsaa naar preorder goer varianten koebbar (data-inventory-soldout fra Liquid)
  var isLabelSoldout = option.disabled || option.getAttribute("data-inventory-soldout") === "true";

  if (isPlaceholder) {
    option.textContent = "Vælg størrelse";
    return;
  }

  option.textContent = baseLabel + " (" + pillowCount + " stk.)" + (isLabelSoldout ? " - Udsolgt" : "");
});

pillowSelect.disabled = false;

        if (pillowQuantityInput) pillowQuantityInput.value = pillowCount;
if (pillowCountLabel) pillowCountLabel.textContent = pillowCount + " stk.";

if (!hasAvailableDuvetOption || !selectedDuvetValue) {
  if (pillowVariantIdInput) pillowVariantIdInput.value = "";
  if (pillowVariantLabelInput) pillowVariantLabelInput.value = "";

  if (helper) {
    helper.textContent = "Dynebetræk er midlertidigt udsolgt i alle størrelser.";
    helper.classList.add("is-visible");
  }

  setAddToCartState(false, "Midlertidigt udsolgt");
  return;
}
if (!selectedPillowOption || selectedPillowOption.disabled) {
  if (pillowVariantIdInput) pillowVariantIdInput.value = "";
  if (pillowVariantLabelInput) pillowVariantLabelInput.value = "";

  if (helper) {
    helper.textContent = "Pudebetræk er midlertidigt udsolgt i alle størrelser.";
    helper.classList.add("is-visible");
  }

  setAddToCartState(false, "Midlertidigt udsolgt");
  return;
}

        const selectedPillowLabel = selectedPillowOption.getAttribute("data-label") || selectedPillowOption.text;
       

        if (pillowVariantIdInput) pillowVariantIdInput.value = pillowSelect.value;
        if (pillowVariantLabelInput) pillowVariantLabelInput.value = selectedPillowLabel;

        if (helper && template) {
          helper.textContent = template.replace("[SIZE]", selectedPillowLabel);
          if (showMessage) helper.classList.add("is-visible");
        }

        const mainVariant = variants.find(function (v) {
          return String(v.id) === String(duvetSelect.value);
        });

        const isAvailable = !!selectedPillowOption && !selectedPillowOption.disabled && (!mainVariant || mainVariant.available);
        setAddToCartState(isAvailable, "Midlertidigt udsolgt");
      }

      // Bundle-vaelgeren bruger ikke temaets variantvaelger, saa temaets
      // lagerstatus-blok ("Paa lager", "Kun X tilbage", "Forventes paa lager")
      // blev foerst opdateret ved reload. Vi kalder temaets egen updateInventory
      // direkte paa produktsektionens instans i stedet for at udsende
      // variantChange, saa vi ikke ogsaa udloeser knaptekst, billedskift,
      // butikslager og BIS-logik, der styres af bundle-koden her.
      function updateThemeInventory(variantId) {
        if (!section.querySelector("[data-product-inventory]")) return;
        if (!section.querySelector("[data-incoming-inventory]")) return;

        const themeSections = window.theme && theme.sections;
        const instances = (themeSections && themeSections.instances) || [];

        const productInstance = instances.find(function (instance) {
          return instance && instance.container === section && typeof instance.updateInventory === "function";
        });

        if (!productInstance) return;

        const variant = variants.find(function (v) {
          return String(v.id) === String(variantId);
        }) || null;

        try {
          productInstance.updateInventory({ detail: { variant: variant } });
        } catch (error) {
          console.error("Kunne ikke opdatere lagerstatus:", error);
        }
      }

      duvetSelect.addEventListener("change", function () {
        updateMainVariantUI(this.value);
        updateHelper(true);
        updateThemeInventory(this.value);
      });

      pillowSelect.addEventListener("change", function () {
        updateHelper(true);
      });

      updateMainVariantUI(duvetSelect.value);
      updateHelper(true);

      let bundleSubmitInProgress = false;

      form.addEventListener(
        "submit",
        async function (event) {
          if (!section.querySelector("[data-bedding-bundle-picker]")) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (bundleSubmitInProgress) return;

          const mainVariantId = duvetSelect.value;
          // form.elements finder ogsaa antal-feltet naar det staar uden for
          // form-elementet og kun er koblet via form-attributten
          const mainQtyField = form.elements.quantity || form.querySelector('[name="quantity"]');
          const mainQuantity = Math.max(1, parseInt(mainQtyField?.value || 1, 10) || 1);
          const pillowVariantId = pillowVariantIdInput?.value || "";
          const pillowLabel = pillowVariantLabelInput?.value || "";
          const pillowPerSet = parseInt(pillowQuantityInput?.value || 1, 10);
          const pillowTotalQty = mainQuantity * pillowPerSet;

          if (!pillowVariantId) {
            console.error("Ingen tilgængelig pudebetræk variant valgt");
            return;
          }

          const submitBtn = form.querySelector(".add-to-cart, [data-add-to-cart]");
          const submitText = form.querySelector("[data-add-to-cart-text]");
          const originalText = submitText ? submitText.textContent : "";

          bundleSubmitInProgress = true;
          if (submitBtn) submitBtn.disabled = true;
          if (submitText) submitText.textContent = "Tilføjer...";

          const parentKey = "parent_" + mainVariantId;
          const childKey = "child_" + pillowVariantId;

          try {
            const response = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: JSON.stringify({
                items: [
                  {
                    id: parseInt(mainVariantId, 10),
                    quantity: mainQuantity,
                    properties: {
                      _bundle_type: "bedding_set",
                      _bundle_role: "parent",
                      _bundle_key: parentKey,
                      _child_link_key: childKey,
                      _linked_pillow_variant_id: String(pillowVariantId),
                      _linked_pillow_quantity_per_set: String(pillowPerSet)
                    }
                  },
                  {
                    id: parseInt(pillowVariantId, 10),
                    quantity: pillowTotalQty,
                    properties: {
                      _bundle_type: "bedding_set",
                      _bundle_role: "child",
                      _bundle_key: childKey,
                      _bundle_parent_product_title: productTitle,
                      _bundle_pillow_size: pillowLabel
                    }
                  }
                ]
              })
            });

            if (!response.ok) throw new Error("Fejl ved tilføjelse");

            if (window.refreshCartDrawerContents) {
              await new Promise(function (resolve) {
                setTimeout(resolve, 250);
              });

              await window.refreshCartDrawerContents();

              document.dispatchEvent(new CustomEvent("cart:updated"));
              document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
              document.dispatchEvent(new CustomEvent("cart:open"));
            } else {
              window.location.href = "/cart";
            }
          } catch (error) {
            console.error("Bundle Error:", error);
          } finally {
            bundleSubmitInProgress = false;
            updateHelper(true);

            if (submitBtn) submitBtn.disabled = false;
            if (submitText) submitText.textContent = originalText || "Tilføj til kurv";
          }
        },
        true
      );
    });
  }

  // Klaviyo back-in-stock under Forudbestil-knappen (Essential Preorder).
  // Markup renderes skjult af snippets/wl-preorder-bis.liquid; her styres synlighed og tilmelding.
  function initPreorderBis(scope = document) {
    const blocks = scope.querySelectorAll("[data-wl-preorder-bis]");
    if (!blocks.length) return;

    function getKlaviyoCompanyId() {
      const scripts = document.querySelectorAll('script[src*="klaviyo"]');
      for (const script of scripts) {
        try {
          const url = new URL(script.src, window.location.href);
          const param = url.searchParams.get("company_id");
          if (param) return param;
          const match = url.pathname.match(/\/onsite\/js\/([A-Za-z0-9]+)\/klaviyo/);
          if (match) return match[1];
        } catch (error) {
          // Ugyldig script-src springes over
        }
      }
      return "";
    }

    blocks.forEach(function (block) {
      if (block.dataset.wlBisBound === "true") return;
      block.dataset.wlBisBound = "true";

      const companyId = getKlaviyoCompanyId();
      if (!companyId) return;

      const section = block.closest(".product-section");
      const jsonEl = block.querySelector("[data-wl-bis-variants]");
      const soldOutByVariant = jsonEl ? parseJSONSafe(jsonEl.textContent, {}) : {};
      const toggle = block.querySelector("[data-wl-bis-toggle]");
      const form = block.querySelector("[data-wl-bis-form]");
      const emailInput = block.querySelector("[data-wl-bis-email]");
      const message = block.querySelector("[data-wl-bis-message]");

      if (!toggle || !form || !emailInput || !message) return;

      let currentVariantId = block.dataset.initialVariant || "";
      let submitInProgress = false;

      function readVariantIdFromForm() {
        if (!section) return "";
        const input = section.querySelector('.product-single__form [name="id"]');
        return input && input.value ? String(input.value) : "";
      }

      function setMessage(text, type) {
        message.textContent = text || "";
        message.hidden = !text;
        message.classList.toggle("note--success", type === "success");
        message.classList.toggle("errors", type === "error");
      }

      function setExpanded(expanded) {
        toggle.setAttribute("aria-expanded", String(expanded));
        form.hidden = !expanded;
      }

      function updateVisibility() {
        const isSoldOut = soldOutByVariant[String(currentVariantId)] === true;
        block.hidden = !isSoldOut;
        if (!isSoldOut) {
          setExpanded(false);
          setMessage("", "");
        }
      }

      function setCurrentVariant(variantId) {
        const next = variantId ? String(variantId) : "";
        if (next === currentVariantId) return;
        currentVariantId = next;
        setMessage("", "");
        updateVisibility();
      }

      toggle.addEventListener("click", function () {
        const expanded = toggle.getAttribute("aria-expanded") === "true";
        setExpanded(!expanded);
        if (!expanded) emailInput.focus();
      });

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        if (submitInProgress) return;

        if (!emailInput.checkValidity()) {
          setMessage(block.dataset.textInvalid, "error");
          emailInput.focus();
          return;
        }

        const variantId = currentVariantId || readVariantIdFromForm();
        if (!variantId) {
          setMessage(block.dataset.textError, "error");
          return;
        }

        submitInProgress = true;
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        setMessage("", "");

        fetch(
          "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" +
            encodeURIComponent(companyId),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              revision: "2024-10-15"
            },
            body: JSON.stringify({
              data: {
                type: "back-in-stock-subscription",
                attributes: {
                  channels: ["EMAIL"],
                  profile: {
                    data: {
                      type: "profile",
                      attributes: { email: emailInput.value.trim() }
                    }
                  }
                },
                relationships: {
                  variant: {
                    data: {
                      type: "catalog-variant",
                      id: "$shopify:::$default:::" + variantId
                    }
                  }
                }
              }
            })
          }
        )
          .then(function (response) {
            if (!response.ok) throw new Error("Klaviyo-svar " + response.status);
            setExpanded(false);
            setMessage(block.dataset.textSuccess, "success");
          })
          .catch(function (error) {
            console.error("Klaviyo back-in-stock fejlede:", error);
            setMessage(block.dataset.textError, "error");
          })
          .finally(function () {
            submitInProgress = false;
            if (submitBtn) submitBtn.disabled = false;
          });
      });

      if (section) {
        section.addEventListener("variantChange", function (event) {
          const variant = event.detail ? event.detail.variant : null;
          setCurrentVariant(variant ? variant.id : "");
        });

        // Fallback for variantskift der ikke udloeser variantChange (fx bundle-vaelgeren)
        section.addEventListener("change", function () {
          window.setTimeout(function () {
            const fromForm = readVariantIdFromForm();
            if (fromForm) setCurrentVariant(fromForm);
          }, 0);
        });
      }

      const initialFromForm = readVariantIdFromForm();
      if (initialFromForm) currentVariantId = initialFromForm;
      updateVisibility();
    });
  }

  function initVariantChangeHelpers() {
    if (document.body.dataset.variantChangeHelperBound === "true") return;
    document.body.dataset.variantChangeHelperBound = "true";

    document.addEventListener("variant:change", function (event) {
      const variant = event.detail?.variant;
      if (!variant) return;

      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());

      document.querySelectorAll('.custom-related-product form[action^="/cart/add"]').forEach(function (form) {
        const input = form.querySelector('input[name="id"]');
        const select = form.querySelector('select[name="id"]');

        if (input) input.value = variant.id;
        if (select && select.querySelector(`option[value="${variant.id}"]`)) {
          select.value = String(variant.id);
        }
      });
    });
  }

  function initAddonUpsells() {
    if (document.body.dataset.addonUpsellBound === "true") return;
    document.body.dataset.addonUpsellBound = "true";

    document.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-addon-toggle]");
      if (!toggle) return;

      var wrapper = toggle.closest("[data-addon-upsell]");
      var panel = wrapper ? wrapper.querySelector(".wl-addon-upsell__panel") : null;
      if (!panel) return;

      var isOpen = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
      panel.hidden = isOpen;
    });

    document.addEventListener("change", function (event) {
      var select = event.target.closest("[data-addon-variant-select]");
      if (!select) return;

      var wrapper = select.closest("[data-addon-upsell]");
      var addButton = wrapper ? wrapper.querySelector(".add-upsell-to-cart") : null;
      if (addButton) addButton.dataset.id = select.value;
    });
  }

  function initVideoJump(scope) {
    // Play-genvej paa produktsiden: svinger hovedslideren over til foerste video.
    // Markup i snippets/product-images.liquid, CSS i wonderliving.css.liquid.
    scope.querySelectorAll("[data-wl-video-jump]").forEach(function (button) {
      if (button.dataset.wlVideoJumpBound === "true") return;
      button.dataset.wlVideoJumpBound = "true";

      var photos = button.closest(".product__main-photos");
      var slider = photos ? photos.querySelector("[data-product-photos]") : null;
      var section = button.closest("[data-section-id]");
      var index = parseInt(button.dataset.videoIndex, 10);
      if (!slider || !section || isNaN(index)) return;

      function goToVideo() {
        var instance =
          window.theme && theme.sections && typeof theme.sections._findInstance === "function"
            ? theme.sections._findInstance(section.dataset.sectionId)
            : null;

        if (instance && instance.flickity && typeof instance.flickity.goToSlide === "function") {
          instance.flickity.goToSlide(index);
          return;
        }

        // Fallback: temaets egen thumbnail-navigation
        var thumb = section.querySelector('.product__thumb-item[data-index="' + index + '"] a');
        if (thumb) thumb.click();
      }

      function syncVisibility() {
        var selected = slider.querySelector(".product-main-slide.is-selected");
        var onVideo = !!(selected && selected.querySelector(".product__video-wrapper, .product-video-trigger"));
        button.classList.toggle("wl-video-jump--hidden", onVideo);
      }

      button.addEventListener("click", goToVideo);

      // Flickity skifter .is-selected paa slides; skjul knappen mens videoen er aktiv.
      new MutationObserver(syncVisibility).observe(slider, {
        attributes: true,
        attributeFilter: ["class"],
        subtree: true
      });
      syncVisibility();
    });
  }

  function runInitializers(scope = document) {
    initVariantSelectors(scope);
    initAjaxAddToCart(scope);
    initBeddingBundle(scope);
    initSizeFilter();
    initLoadMore();
    initVariantMetafieldHTML();
    initVariantMetaFields();
    initPreorderBis(scope);
    initVariantChangeHelpers();
    initGlobalQtyButtons();
    initTextToggles();
    initCollectionReadMore(scope);
    initAddonUpsells();
    initVideoJump(scope);
  }

  document.addEventListener("DOMContentLoaded", function () {
    runInitializers(document);
    initCartDrawer();

    const recommendations = document.querySelector("product-recommendations");
    if (recommendations) {
      const observer = new MutationObserver(function () {
        runInitializers(recommendations);
      });

      observer.observe(recommendations, {
        childList: true,
        subtree: true
      });
    }
  });

  document.addEventListener("page:loaded", function () {
    runInitializers(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    runInitializers(event.target);
    bindCartEvents();
  });
})();


